import { render } from "./CelebrationProse.vue?vue&type=template&id=d688af00&scoped=true"
import script from "./CelebrationProse.vue?vue&type=script&lang=js"
export * from "./CelebrationProse.vue?vue&type=script&lang=js"

import "./CelebrationProse.vue?vue&type=style&index=0&id=d688af00&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d688af00"]])

export default __exports__